// @ts-nocheck
// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { tag } from 'omi';
import { IconBase, IconProps } from '../icon';

const element = {"attributes":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"nodeName":"svg","children":[{"attributes":{"fill":"currentColor","d":"M4 20V2H2V22H22V20H20V16.5H14V20H12V16.5H6V20H4Z"},"nodeName":"path","children":[]},{"attributes":{"fill":"currentColor","d":"M6 14.5H12V9H6V14.5Z"},"nodeName":"path","children":[]},{"attributes":{"fill":"currentColor","d":"M14 14.5H20V5H14V14.5Z"},"nodeName":"path","children":[]}]};

@tag('t-icon-chart-stacked-filled')
export default class ChartStackedFilledIcon extends IconBase<IconProps> {
  static icon = element;
  constructor() {
    super();
    this.props = {
      ...this.props,
      id: 'chart-stacked-filled',
    }
  }
}
